import { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const ModalEdicaoProduto = ({ produto, onSave, onClose}) => {
 const [produtoEditado, setProdutoEditado] = useState({
  ...produto,
  QTD_EMBALAGEM: produto.QTD_EMBALAGEM || 1,
  QTD_UNITIZADA: produto.QTD || 0,
});


// ==========================================
// CÁLCULO DE QUANTIDADE UNITIZADA
// ==========================================
useEffect(() => {
  const qtdPedida = Number(produtoEditado.QTD) || 0;
  const qtdEmbalagem = Number(produtoEditado.QTD_EMBALAGEM) || 1;

  const qtdUnitizada = qtdPedida * qtdEmbalagem;

  setProdutoEditado((prev) => ({
    ...prev,
    QTD_UNITIZADA: qtdUnitizada,
  }));
}, [
  produtoEditado.QTD,
  produtoEditado.QTD_EMBALAGEM,
]);


// ==========================================
// CÁLCULO DOS IMPOSTOS E TOTAL
// ==========================================
useEffect(() => {
  const quantidade = Number(produtoEditado.QTD) || 0;
  const valorUnitario = Number(produtoEditado.COMPRA) || 0;

  // =========================
  // TOTAL
  // =========================
  const total = Number((quantidade * valorUnitario).toFixed(2));

  // =========================
  // ALÍQUOTAS
  // =========================
  const aliIcms = Number(produtoEditado.ALI_ICMS) || 0;
  const aliIpi = Number(produtoEditado.ALI_IPI) || 0;
  const aliPis = Number(produtoEditado.ALI_PIS) || 0;
  const aliCofins = Number(produtoEditado.ALI_COFINS) || 0;

  // =========================
  // BASES
  // =========================
  const bcIcms = aliIcms > 0 ? total : 0;
  const bcIpi = total;
  const bcPis = total;
  const bcCofins = total;

  // =========================
  // VALORES
  // =========================
  const valorIcms = Number(((bcIcms * aliIcms) / 100).toFixed(2));
  const valorIpi = Number(((bcIpi * aliIpi) / 100).toFixed(2));
  const valorPis = Number(((bcPis * aliPis) / 100).toFixed(2));
  const valorCofins = Number(((bcCofins * aliCofins) / 100).toFixed(2));

  setProdutoEditado((prev) => ({
    ...prev,

    // TOTAL
    TOTAL: total,

    // ICMS
    BC_ICMS: bcIcms,
    VALOR_ICMS: valorIcms,

    // IPI
    BC_IPI: bcIpi,
    VALOR_IPI: valorIpi,

    // PIS
    BC_PIS: bcPis,
    VALOR_PIS: valorPis,

    // COFINS
    BC_COFINS: bcCofins,
    VALOR_COFINS: valorCofins,
  }));
}, [
  produtoEditado.QTD,
  produtoEditado.COMPRA,
  produtoEditado.ALI_ICMS,
  produtoEditado.ALI_IPI,
  produtoEditado.ALI_PIS,
  produtoEditado.ALI_COFINS,
]);
  
  

  const handleChange = (campo, valor) => {
    setProdutoEditado((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const handleChangeImposto = (tipo, campo, valor) => {
    setProdutoEditado((prev) => ({
      ...prev,
      imposto: {
        ...prev.imposto,
        [tipo]: {
          ...prev.imposto[tipo],
          [campo]: valor,
        },
      },
    }));
  };

  return (
    <Modal show onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Editar Produto</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-2">
            <Col md={5}>
              <Form.Group>
                <Form.Label>Código</Form.Label>
                <Form.Control type="text" value={produtoEditado.COD_PRODUTO} readOnly />
              </Form.Group>
            </Col>

            

            <Col md={5}>
              <Form.Group>
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  type="text"
                  value={produtoEditado.DESCRICAO}
                  onChange={(e) => handleChange("DESCRICAO", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md={2}>
              <Form.Group>
                <Form.Label>Unidade</Form.Label>
                <Form.Control
                  type="text"
                  value={produtoEditado.UNIDADE}
                  onChange={(e) => handleChange("UNIDADE", e.target.value)}
                />
              </Form.Group>
            </Col>


            <Col md={2}>
              <Form.Group>
                <Form.Label>CFOP</Form.Label>
                <Form.Control
                  type="text"
                  value={produtoEditado.CFOP}
                  onChange={(e) => handleChange("CFOP", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>Valor</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.COMPRA).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("COMPRA", e.target.value)}
                />
              </Form.Group>
            </Col>
          
<Col md={2}>
  <Form.Group>
    <Form.Label>Qtd Embalagem</Form.Label>
    <Form.Control
      type="number"
      value={produtoEditado.QTD_EMBALAGEM}
      onChange={(e) =>
        handleChange("QTD_EMBALAGEM", e.target.value)
      }
    />
  </Form.Group>
</Col>

<Col md={2}>
  <Form.Group>
    <Form.Label>Qtd Pedida</Form.Label>
    <Form.Control
      type="number"
      value={produtoEditado.QTD}
      onChange={(e) =>
        handleChange("QTD", e.target.value)
      }
    />
  </Form.Group>
</Col>

<Col md={2}>
  <Form.Group>
    <Form.Label>Qtd Unitizada</Form.Label>
    <Form.Control
      type="number"
      value={produtoEditado.QTD_UNITIZADA}
     
    />
  </Form.Group>
</Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>Total</Form.Label>
                <Form.Control type="text" value={Number(produtoEditado.TOTAL).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                onChange={(e) => handleChange("TOTAL", e.target.value)}/>

              </Form.Group>
            </Col>
          </Row>

          {/* ICMS */}
          <h6 className="mt-3">ICMS</h6>
          <Row className="mb-2">
            <Col md={3}>
              <Form.Group>
                <Form.Label>CST (ICMS)</Form.Label>
                <Form.Control
                  type="text"
                  value={produtoEditado.ST_ICMS}
                  onChange={(e) => handleChange( "ST_ICMS", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>BC (ICMS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.BC_ICMS).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("BC_ICMS", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>% (ICMS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.ALI_ICMS).toFixed(2) + "%" }
                  onChange={(e) => handleChange("ALI_ICMS", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>VALOR (ICMS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.VALOR_ICMS).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("VALOR_ICMS", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

         
          <h6 className="mt-3">IPI</h6>
          <Row className="mb-2">
            <Col md={3}>
              <Form.Group>
                <Form.Label>CST (IPI)</Form.Label>
                <Form.Control
                  type="text"
                  value={produtoEditado.ST_IPI}
                  onChange={(e) => handleChange("ST_IPI", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>BC (IPI)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.BC_IPI).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("BC_IPI", e.target.value)}
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>% (IPI)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.ALI_IPI).toFixed(2) + "%"}
                  onChange={(e) => handleChange("ALI_IPI", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>VALOR (IPI)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.VALOR_IPI).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("VALOR_IPI", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>


    
          <h6 className="mt-3">PIS</h6>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>CST (PIS)</Form.Label>
                <Form.Control
                  type="text"
                  value={produtoEditado.ST_PIS}
                  onChange={(e) => handleChange("ST_PIS", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>BC (PIS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.BC_PIS).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("BC_PIS", e.target.value)}
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>% (PIS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.ALI_PIS).toFixed(2) + "%"}
                  onChange={(e) => handleChange("ALI_PIS", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>VALOR (PIS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.VALOR_PIS).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("VALOR_PIS", e.target.value)}
                />
              </Form.Group>
            </Col>
         </Row>

          <h6 className="mt-3">COFINS</h6> 
         <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>CST (COFINS)</Form.Label>
                <Form.Control
                  type="text"
                  value={produtoEditado.ST_COFINS}
                  onChange={(e) => handleChange("ST_COFINS", e.target.value)}
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>BC (COFINS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.BC_COFINS).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("BC_COFINS", e.target.value)}
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>% (COFINS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.ALI_COFINS).toFixed(2) + "%"}
                  onChange={(e) => handleChange("ALI_COFINS", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>VALOR (COFINS)</Form.Label>
                <Form.Control
                  type="text"
                  value={Number(produtoEditado.VALOR_COFINS).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                  onChange={(e) => handleChange("VALOR_COFINS", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={() => onSave(produtoEditado)}>
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEdicaoProduto;
